import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { EditIcon } from '../components/shared/Icons';
import FilterPeriodical from './FilterPeriodical';
import FilterSouthYarra from './FilterSouthYarra';
import FilterTickets from './FilterTickets';
import FilterExtrawork from './FilterExtrawork';
import FilterReplacement from './FilterReplacement';
import FilterLeave from './FilterLeave';


const TABS = [
  {
    id: 'updateleave',
    label: 'Leave',
    
  },
  {
    id: 'updateclient',
    label: 'Client',
    
  },
];


const UPDATE_INNER_LEAVE = [
  { id: 'leaveupdate', label: 'Leave', icon: <EditIcon />, component: FilterLeave },
  { id: 'replacementupdate', label: 'Replacement', icon: <EditIcon />, component: FilterReplacement },
  { id: 'extraworkupdate', label: 'Extra Work', icon: <EditIcon />, component: FilterExtrawork },
];


const UPDATE_INNER_CLIENT = [
  { id: 'periodicalupdate', label: 'Periodical', icon: <EditIcon />, component: FilterPeriodical },
  { id: 'southyarraupdate', label: 'South Yarra', icon: <EditIcon />, component: FilterSouthYarra },
  { id: 'ticketupdate', label: 'Ticket', icon: <EditIcon />, component: FilterTickets },
];

const FilterSuperClientUpdatePagem = () => {
  const [activeTab, setActiveTab] = useState('updateleave');
  const { homeAccent } = useUser();

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'updateleave' && <InnerTabsm tabs={UPDATE_INNER_LEAVE} defaultId="leaveupdate"/>}
        {activeTab === 'updateclient' && <InnerTabsm tabs={UPDATE_INNER_CLIENT} />}
      </div>
    </div>
  );
};

export default FilterSuperClientUpdatePagem;